var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nuxt-link', {
    class: ("sale-marker sale-marker_" + (_vm.type)),
    style: _vm.styles,
    attrs: {
      "to": ("/sales/" + (_vm.sale.code) + "/")
    }
  }, [_vm._v("\n  " + _vm._s(_vm.sale.marker.name) + "\n")]);
}
var staticRenderFns = []

export { render, staticRenderFns }